//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ApartmentTooltip",
  props: ["apartment"],
  data: function() {
    return {
      status: status
    };
  }
};



// WEBPACK FOOTER //
// ./scripts/vue/partials/ApartmentTooltip.vue